'use strict';

const BasePresenter = require('./base');

class BookerPresenter extends BasePresenter {
  constructor() {
    super(...arguments);
    this.setModule('glive_booking_redesign');
    if (this.isARSE) this.localesBasePath = `${this.localesBasePath}_arse`;
  }

  toHash() {
    const error = this.model.get('error');
    const hash = {
      error,
      errorLoading: error === 'loading' || error === 'timeout',
      errorBooking: error === 'server' || error === 'not_found',
      errorSegmentNotAvailable: error === 'conflict',
      errorSegmentExpired: error === 'gone',
      myReservationsLink: `/users/${this.model.get('userId')}/reservations`,
      myGrouponsLink: `/users/${this.model.get('userId')}/groupons`,
      isOpen: this.options.isOpen,
      isLocked: this.options.isLocked,
      isARSE: this.isARSE,
      showNewOverlay: this.options.showNewOverlay,
      phoneRequired: this.model.requirePhone(),
      questionRequired: this.model.requireQuestion(),
    };
    return hash;
  }
}

module.exports = BookerPresenter;
